import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { TxKeyword, User } from '../../../_models';
import { TxKeywordService, AuthenticationService, NotificationService,  EnvService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({ templateUrl: './keyword-list.component.html' })
export class TxKeywordListComponent implements OnInit {
  filterForm: FormGroup;
  newKeywordForm: FormGroup;
  keywords: TxKeyword[];
  currentUser: User;
  sourceList = {};
  typeList = {};
  countryList: any = [];
  intervalList = {};
  categoryList = [];
  operatorList: any = [];
  filterOperatorList: any = [];
  loading = false;
  processing = false;
  showError = false;
  itemsPerPage = 10;
  pagingList = [10, 20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = false;
  maxPageSize: number;

  initialized = false;

  filterable = {
    source: null,
    operator: null,
    country: null
  };

  constructor(private fb: FormBuilder,
    private envSvc: EnvService,
    private authSvc: AuthenticationService,
    private keywordSvc: TxKeywordService,
    private notification: NotificationService,
    private modalService: NgbModal) {

    this.currentUser = this.authSvc.currentUserValue;
  }

  ngOnInit(): void {
    this.loadAllCountries();
    this.loadAllSources();
    this.loadAllCategories();
    this.loadPage(1);
  }

  openModal(targetModal, keyword = null) {
    if(this.initialized == false){
      this.loadIntervals();
      this.loadKeywordTypes();
      this.initialized = true;
    }

    this.processing = false;
    this.showError = false;
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });

    this.newKeywordForm = this.fb.group({
      source: ['', Validators.required],
      shortCode: ['', Validators.required],
      keyword: ['', Validators.required],
      secondKeyword: [''],
      productId: [''],
      operator: ['', Validators.required],
      operatorId: [''],
      country: ['', Validators.required],
      mcc: [''],
      mnc: [''],
      price: ['', Validators.required],
      priceId: [''],
      category: [1, Validators.required],
      interval: [3, Validators.required],
      schedules: ['', Validators.required],
      contentSchedules: [''],
      minHour: [9, Validators.required],
      maxHour: [20, Validators.required],
      mtContentEnabled: [false, Validators.required],
      renewalEnabled: [false, Validators.required],
      broadcast: [false, Validators.required],
      txPrefix: [''],
      senderId: ['']
    });
    this.operatorList = [];
  }

  get f() { return this.newKeywordForm.controls; }

  search(): void {
    this.totalItems = 0;
    this.loadPage(1);
  }

  clear(): void {
    this.filterable = {
      source: null,
      operator: null,
      country: null,
    };
    this.filterOperatorList = [];
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  onSubmit() {
    this.processing = true;
    var newDataParam = this.newKeywordForm.getRawValue();
    newDataParam.country = newDataParam.country.code;
    if (this.newKeywordForm.valid) {

      if (confirm("Are you sure to add the keyword now?")) {
        this.keywordSvc.addKeyword(newDataParam).subscribe(data => {
          if (data !== null) {
            if (data.status == 1) {
              this.notification.showSuccess("Keyword added successfully!", "New Keyword");
              this.modalService.dismissAll();
              this.loadPage(1);
            } else {
              this.notification.showError(data.msg, "Fail to add");
            }
          } else {
            this.notification.showError("Failed to add keyword, please try again later.", "Fail to add");
          }
        })
      }
      this.processing = false;
    } else {
      this.showError = true;
      this.notification.showError("Some fields are missing", "Add failed");
      this.processing = false;
    }
  }

  deleteKeyword(keyword) {
    if (confirm("Are you sure to delete this keyword?")) {
      this.keywordSvc.deleteKeyword(keyword.id).subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("Keyword deleted successfully!", "Delete Keyword");
          this.loadPage(1);
        } else {
          this.notification.showError("Error deleting keyword, please try again later.", "Error");
        }
      })
    }
  }

  changeCountry(country) { //new keyword
    if (this.newKeywordForm.getRawValue().operator) {
      this.newKeywordForm.patchValue({
        operator: '',
      });
    }
    if (country) {
      this.operatorList = country.operators;
    }
  }

  changeFilCountry(country){
    this.filterable.operator = null;
    this.filterOperatorList = country.operators;
    console.log(country.operators);
  }

  private loadAllSources() {
    this.envSvc.getSources().pipe(first()).subscribe(data => {
      this.sourceList = data.data;
    });
  }

  private loadKeywordTypes() {
    this.envSvc.getKeywordTypes().pipe(first()).subscribe(data => {
      this.typeList = data.data;
    });
  }

  private loadIntervals() {
    this.envSvc.getIntervalModes().pipe(first()).subscribe(data => {
      this.intervalList = data.data;
    });
  }

  private loadAllCountries() {
    this.envSvc.getCountries().pipe(first()).subscribe(data => {
      this.countryList = data.data;
    });
  }

  private loadAllCategories() {
    this.categoryList = this.envSvc.getKeywordCategories();
  }

  private loadPage(page = null) {
    this.loading = true;
    this.keywords = [];
    let params = this.formParam(page);

    // get page of items from api
    this.keywordSvc.getAll(params).pipe(first()).subscribe(data => {
      if (data !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.totalItems = data.data.total;
        this.keywords = data.data.list;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.maxPageSize = 0;
        this.notification.showWarning("There is no record for this admin.", "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      source: this.filterable.source,
      operator: this.filterable.operator == null ? "" : this.filterable.operator,
      country: this.filterable.country == null ? "" : this.filterable.country.code,
    }
    return params;
  }

}
